module.exports = __webpack_public_path__ + "static/media/us.7fa987eb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/us.svg
// module id = 2011
// module chunks = 1